import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getNotificationList } from "../../../apis/notificationApi";
import { Table } from "antd";

const NotificationDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    name: "",
    email: "",
    role: "",
    status: "",
    from: "",
    to: "",
  });

  useEffect(() => {
    fetchNotificationDetails();
  }, []);

  const fetchNotificationDetails = async (filterParams = {}) => {
    // setLoading(true);
    try {
      const res = await getNotificationList(id, filterParams);
      setDetails(res?.result?.sentUsers || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const onSearch = () => {
    fetchNotificationDetails(filters);
  };

  const onClear = () => {
    const cleared = {
      name: "",
      email: "",
      role: "",
      status: "",
      from: "",
      to: "",
    };
    setFilters(cleared);
    fetchNotificationDetails({});
  };

  const backClick = () => {
    navigate("/Notifications");
  };

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) => index + 1,
      width: "5%",
    },
    {
      title: "Name",
      render: (_, record) => `${record.firstName} ${record.lastName || ""}`,
      width: "20%",
    },
    {
      title: "Email",
      dataIndex: "email",
      width: "25%",
    },
    {
      title: "Role",
      dataIndex: "role",
      width: "10%",
    },
    {
      title: "Status",
      dataIndex: "Status",
      width: "10%",
    },
    {
      title: "Read At",
      dataIndex: "Read_At",
      width: "15%",
      render: (text) => (text ? text.split("T")[0] : "-"),
    },
    {
      title: "Device",
      dataIndex: "Device",
      width: "10%",
    },
  ];

  return (
    <div className="main-wrapper">
      <div className="page-wrapper">
        <div className="content container-fluid">
          <i
            className="fas fa-arrow-left"
            style={{ marginRight: 20, fontSize: 20, cursor: "pointer" }}
            onClick={backClick}
          />

          <div
            style={{
              display: "flex",
              gap: 10,
              flexWrap: "wrap",
              margin: "15px 0",
            }}
          >
            <input
              className="form-control"
              placeholder="Name"
              value={filters.name}
              onChange={(e) => setFilters({ ...filters, name: e.target.value })}
              style={{ width: 180 }}
            />

            <input
              className="form-control"
              placeholder="Email"
              value={filters.email}
              onChange={(e) =>
                setFilters({ ...filters, email: e.target.value })
              }
              style={{ width: 200 }}
            />

            <select
              className="form-control"
              value={filters.role}
              onChange={(e) => setFilters({ ...filters, role: e.target.value })}
              style={{ width: 150 }}
            >
              <option value="">All Roles</option>
              <option value="broker">Broker</option>
              <option value="user">User</option>
            </select>

            <select
              className="form-control"
              value={filters.status}
              onChange={(e) =>
                setFilters({ ...filters, status: e.target.value })
              }
              style={{ width: 150 }}
            >
              <option value="">All Status</option>
              <option value="Read">Read</option>
              <option value="Unread">Unread</option>
            </select>

            <input
              type="date"
              className="form-control"
              value={filters.from}
              onChange={(e) => setFilters({ ...filters, from: e.target.value })}
              style={{ width: 200 }}
            />

            <input
              type="date"
              className="form-control"
              value={filters.to}
              onChange={(e) => setFilters({ ...filters, to: e.target.value })}
              style={{ width: 200 }}
            />

            <button className="btn btn-primary" onClick={onSearch}>
              Search
            </button>

            <button className="btn btn-secondary" onClick={onClear}>
              Clear
            </button>
          </div>

          <Table
            columns={columns}
            dataSource={details}
            rowKey={(record) => record.ID}
            pagination={{ pageSize: 10 }}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationDetails;
